/* eslint-disable react/prop-types */
import React from 'react';
import { Link } from 'react-router-dom';

const NavBar = () => (
  <div>
    <h1>
      <Link to="/">Konoha-gram</Link>
    </h1>
  </div>
);

export default NavBar;
